import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidatorsService } from '../../../../../shared/modules/inputs/services/custom.validators.service';

export function buildForm() {
  const form = new FormGroup({
    email: new FormControl(null, [
      Validators.required,
      CustomValidatorsService.email,
    ]),
    password: new FormControl(null, [
      Validators.required,
      CustomValidatorsService.password,
    ]),
    confirmPassword: new FormControl(null, [Validators.required]),
    recaptcha: new FormControl(null, [Validators.required]),
  });

  form.controls.confirmPassword.addValidators(
    CustomValidatorsService.confirmPassword(form),
  );
  return form;
}
